import React from "react"
import { Modal, ModalBody } from "@silversea-ssc/ui-components-react"
import useSanityContent from "../../app-core/_common/hooks/use-sanity-content"
import { SanityPublicAreasQueryResponse, toSanityLocale } from "../../app-core/_common/sanity/sanity-types"
import { publicAreasContentQuery } from "../../app-core/_common/sanity/sanity-queries"
import { Locale } from "../../app-core/_common/format/localization"
import useModal from "../ModalProvider/useModal"
import PageSpinner from "../PageSpinner/PageSpinner"
import { snakeCase } from "../../app-core/_common/string"
import { ResponsiveSlideshow } from "../Slideshow/Slideshow"
import BlockContent from "../BlockContent/BlockContent"
import styles from "./PublicAreaModal.module.scss"

export type PublicAreaType = "diningAreas" | "facilities"

type Props = {
    locale: Locale
    shipId: string
    shipVersionKey: string
    areaType: PublicAreaType
    areaKey: string
}

const PublicAreaModal: React.FC<Props> = ({ locale, shipId, shipVersionKey, areaType, areaKey }) => {
    const { closeModal } = useModal()
    const sanityLang = toSanityLocale(locale)
    const { isLoading, data: publicAreasContent } = useSanityContent<SanityPublicAreasQueryResponse>(
        `${areaType}-modal-content`,
        publicAreasContentQuery(areaType),
        { shipId: shipId, shipVersionKey: shipVersionKey },
        sanityLang,
    )
    const publicArea = publicAreasContent?.version.publicAreas.find((x) => x._key === areaKey)

    if (!publicArea) return null

    return (
        <Modal
            title={publicArea.card.title}
            modal={{ isOpen: true, onRequestClose: () => closeModal("closeWithCallback") }}
            size="big"
            dataContentName={`modal_${snakeCase(publicArea.card.trackingName)}`}
        >
            <ModalBody>
                {isLoading ? (
                    <PageSpinner />
                ) : (
                    <div className={styles.container}>
                        <div className={styles.leftSide}>
                            {publicArea.images && (
                                <ResponsiveSlideshow items={publicArea.images} variant="gray" fullscreen={false} />
                            )}
                        </div>
                        <div className={styles.rightSide}>
                            <h3>{publicArea.card.title}</h3>
                            <BlockContent value={publicArea.description} />
                        </div>
                    </div>
                )}
            </ModalBody>
        </Modal>
    )
}

export default PublicAreaModal
